import { createReducer } from '@reduxjs/toolkit';

import { actionCreators } from 'store/creditsHistory/actions';
import { CreditsHistoryReducerState, DroppingErrorStatus } from 'store/interfaces';

import { setHeaderTitle } from '../app/acions';
import { Credit } from '../../types/credit';
import { isRide } from '../../types/ride';

const initialState: Readonly<CreditsHistoryReducerState> = {
  isRefreshing: false,
  isLoading: false,
  credits: [],
  isFailedToGet: false,
  droppingRides: {},
  selectedRide: null,
  hasNextPage: false,
};

const creditsHistoryReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(actionCreators.getCreditsHistory.REQUEST, (state, action) => {
      const { isRefreshing } = action.payload;
      state.isRefreshing = !!isRefreshing;
      state.isLoading = true;
    })

    .addCase(actionCreators.getCreditsHistory.SUCCESS, (state, action) => {
      const { credits, hasNextPage } = action.payload;

      state.isLoading = false;
      state.isRefreshing = false;
      state.isFailedToGet = false;
      state.hasNextPage = hasNextPage;
      state.credits = credits;
    })

    .addCase(actionCreators.getCreditsHistory.FAILURE, (state) => {
      state.isLoading = false;
      state.isRefreshing = false;
      state.hasNextPage = false;
      state.isFailedToGet = true;
      state.credits = [];
    })

    .addCase(setHeaderTitle, (state, action) => {
      const { title } = action.payload;

      if (title === '') {
        state.selectedRide = null;
      }
    })

    .addCase(actionCreators.dropRide.REQUEST, (state, action) => {
      const { ride } = action.payload;
      state.droppingRides[ride.id] = ride;
    })

    .addCase(actionCreators.selectRide, (state, action) => {
      const { ride } = action.payload;
      state.selectedRide = ride;
    })

    .addCase(actionCreators.closeDropResultModal, (state, action) => {
      const { rideId } = action.payload;

      delete state.droppingRides[rideId];
    })

    .addCase(actionCreators.dropRide.FULFILL, (state, action) => {
      const { response, rideId } = action.payload;
      const { error_code } = response;

      const errorCode =
        DroppingErrorStatus[error_code] === undefined
          ? DroppingErrorStatus.UnknownError
          : error_code;

      if ([DroppingErrorStatus.NoError, DroppingErrorStatus.AlreadyRefunded].includes(errorCode)) {
        const rideStatus = errorCode === DroppingErrorStatus.NoError ? -1 : 1;
        const credit = state.credits.find(
          (credit: Credit) => isRide(credit.object) && credit.object.id === rideId
        );

        if (state.selectedRide && state.selectedRide.id === rideId) {
          // @ts-ignore
          state.selectedRide.ride_status = rideStatus;
        }

        if (credit && isRide(credit.object)) {
          // @ts-ignore
          credit.object.ride_status = rideStatus;
        }
      }
      //

      if (state.droppingRides[rideId]) {
        state.droppingRides[rideId].code = errorCode;
      }
    })

    .addCase(actionCreators.exitCreditsHistory, () => ({ ...initialState }))
);

export default creditsHistoryReducer;
